<p-confirmDialog />
<div class="grid grid-cols-2 gap-2 py-2">
  <div class="col-span-1">
    <div class="grid grid-cols-1 gap-2">
      <div class="inline-flex relative w-full border border-white dark:border-surface-900 gap-2 items-center rounded-full text-surface-800 bg-surface-100 dark:text-surface-0 dark:bg-surface-800 !py-2.5 !px-4">
        <div class="text-nowrap">SKU :</div>
        {{ ebayStock.sku }}
      </div>

      <app-block-input [(object)]="ebayStock" class="EbayStock" property="prix" label="Prix" type="number" suffix=" €" (isSendingData)="sendingDataHandler($event)"></app-block-input>

      <app-block-input [(object)]="ebayStock" class="EbayStock" property="quantite" label="Quantité" type="number" (isSendingData)="sendingDataHandler($event)"></app-block-input>
    </div>
  </div>
  <div class="col-span-1">
    <app-block-textarea [(object)]="ebayStock" class="EbayStock" property="description_specifique" label="Description spécifique" (isSendingData)="sendingDataHandler($event)"></app-block-textarea>
  </div>
</div>

@if (isLoadingData) {
    <div class="flex justify-center">
        <p-progress-spinner ariaLabel="loading" />
    </div>
}
@else {
  <div cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="onDrop($event)" class="grid grid-cols-12 gap-4 mt-2">
    @for (ebayPhoto of ebayPhotos; track ebayPhoto.id; let idx = $index) {
      <div class="col-span-2" cdkDrag cdkDragBoundary=".p-tabpanel" [cdkDragDisabled]="isUpdatingData && action == 'drop'">
        <div class="col-span-2 rounded-md bg-surface-100 dark:bg-surface-800" *cdkDragPlaceholder></div>
        <div class="card !p-0 relative">
          @if(ebayPhoto.thumbnail_url) {
          <img (click)="showViewer($event)" [src]="apiUrl + ebayPhoto.thumbnail_url" alt="placeholder" class="block rounded-md aspect-square object-cover w-full cursor-zoom-in">
          }
          @else {
          <img (click)="showViewer($event)" [src]="apiUrl + ebayPhoto.photo?.thumbnail_url" alt="placeholder" class="block rounded-md aspect-square object-cover w-full cursor-zoom-in">
          }
          <div class="absolute top-2 left-2 right-2 flex justify-between">
            <p-tag cdkDragHandle icon="pi pi-arrows-alt" severity="contrast" [value]="(ebayPhoto.ordre != null ? ebayPhoto.ordre + 1 : ebayPhoto.ordre) + ''" class="min-w-8 cursor-move" />
            <p-button (click)="deletePhoto(ebayPhoto)" icon="pi pi-trash" size="small" severity="danger"/>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="py-4 flex gap-4 justify-between">
    <div class="flex gap-4">
      @if (ebayStock.publie) {
        <p-button (click)="ebayStockPublish()" label="Mettre à jour" icon="pi pi-sync" [disabled]="ebayPhotos && ebayPhotos.length == 0" [loading]="isUpdatingData && action == 'send'" />
      }
      @else {
        <p-button (click)="ebayStockPublish()" label="Publier" icon="pi pi-upload" [disabled]="ebayPhotos && ebayPhotos.length == 0" [loading]="isUpdatingData && action == 'send'" />
      }
        @if (authService.isAdmin()) {
          <p-button (click)="postEbayStockDebug()" label="Debug" icon="pi pi-microchip" severity="warn" [disabled]="isUpdatingData && action == 'debug'" [loading]="isUpdatingData && action == 'debug'" />
        }
    </div>
    <div class="flex gap-4">
      <p-button (click)="removeBackgroundFromEbayPhoto()" label="Supprimer les arrière-plans" icon="pi pi-expand" [loading]="isUpdatingData && action == 'background'" severity="info" />
      <p-button (click)="reInitEbayPhoto()" label="Réinitialiser les photos" icon="pi pi-sync" [loading]="isUpdatingData && action == 'init'" severity="warn" />
    </div>
  </div>
  @if (isUpdatingData && action == 'background') {
    <div class="text-primary-500 rounded-sm mb-4 border border-primary-500">
      <div class="px-3 py-2">
        Ce traitement peut prendre plusieurs secondes / minutes en fonction du nombre de photos à traiter.
      </div>
      <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
    </div>
  }
}

